import { packagesClient } from "./apiClient";

export const getPackagesList = async () => {
  const response = await packagesClient.post(
    "/api/v1/packages/getpackageslist",
    {},
  );
  return response.data;
};
